import React from 'react';
import { IUserSettingsContextState } from './IUserSettingsContextState';
import { IUserSettingsContextActions } from './IUserSettingsContextActions';

export const UserSettingsContext = React.createContext<
    [IUserSettingsContextState, IUserSettingsContextActions] | undefined
>(undefined);
